/* tslint:disable */
/* eslint-disable */
/**
 * Track API
 * The Track API provides access to SPiDRs and Security Focuses.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { AttachmentFromJSON, AttachmentLinkFromJSON, CommentFromJSON, CreateCommentInputToJSON, GetTaskResponseFromJSON, SearchOrganizationTasksInputToJSON, SearchTasksInputToJSON, TaskCreateInputToJSON, TaskResponseFromJSON, TaskUpdateInputToJSON, TaskUpdateStateInputToJSON, TaskWithDetailsResponseFromJSON, TasksSearchResponseInnerFromJSON, } from '../models';
/**
 *
 */
export class DefaultApi extends runtime.BaseAPI {
    /**
     */
    createOrganizationTaskRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.orgID === null || requestParameters.orgID === undefined) {
                throw new runtime.RequiredError('orgID', 'Required parameter requestParameters.orgID was null or undefined when calling createOrganizationTask.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/organizations/{orgID}/tasks`.replace(`{${"orgID"}}`, encodeURIComponent(String(requestParameters.orgID))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: TaskCreateInputToJSON(requestParameters.taskCreateInput),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => TaskResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    createOrganizationTask(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createOrganizationTaskRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    createOrganizationTaskCommentRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.orgID === null || requestParameters.orgID === undefined) {
                throw new runtime.RequiredError('orgID', 'Required parameter requestParameters.orgID was null or undefined when calling createOrganizationTaskComment.');
            }
            if (requestParameters.taskID === null || requestParameters.taskID === undefined) {
                throw new runtime.RequiredError('taskID', 'Required parameter requestParameters.taskID was null or undefined when calling createOrganizationTaskComment.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/organizations/{orgID}/tasks/{taskID}/comments`.replace(`{${"orgID"}}`, encodeURIComponent(String(requestParameters.orgID))).replace(`{${"taskID"}}`, encodeURIComponent(String(requestParameters.taskID))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: CreateCommentInputToJSON(requestParameters.createCommentInput),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CommentFromJSON(jsonValue));
        });
    }
    /**
     */
    createOrganizationTaskComment(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createOrganizationTaskCommentRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    deleteOrganizationTaskRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.orgID === null || requestParameters.orgID === undefined) {
                throw new runtime.RequiredError('orgID', 'Required parameter requestParameters.orgID was null or undefined when calling deleteOrganizationTask.');
            }
            if (requestParameters.taskID === null || requestParameters.taskID === undefined) {
                throw new runtime.RequiredError('taskID', 'Required parameter requestParameters.taskID was null or undefined when calling deleteOrganizationTask.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/organizations/{orgID}/tasks/{taskID}`.replace(`{${"orgID"}}`, encodeURIComponent(String(requestParameters.orgID))).replace(`{${"taskID"}}`, encodeURIComponent(String(requestParameters.taskID))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    deleteOrganizationTask(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteOrganizationTaskRaw(requestParameters, initOverrides);
        });
    }
    /**
     */
    deleteOrganizationTaskCommentRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.orgID === null || requestParameters.orgID === undefined) {
                throw new runtime.RequiredError('orgID', 'Required parameter requestParameters.orgID was null or undefined when calling deleteOrganizationTaskComment.');
            }
            if (requestParameters.taskID === null || requestParameters.taskID === undefined) {
                throw new runtime.RequiredError('taskID', 'Required parameter requestParameters.taskID was null or undefined when calling deleteOrganizationTaskComment.');
            }
            if (requestParameters.commentID === null || requestParameters.commentID === undefined) {
                throw new runtime.RequiredError('commentID', 'Required parameter requestParameters.commentID was null or undefined when calling deleteOrganizationTaskComment.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/organizations/{orgID}/tasks/{taskID}/comments/{commentID}`.replace(`{${"orgID"}}`, encodeURIComponent(String(requestParameters.orgID))).replace(`{${"taskID"}}`, encodeURIComponent(String(requestParameters.taskID))).replace(`{${"commentID"}}`, encodeURIComponent(String(requestParameters.commentID))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    deleteOrganizationTaskComment(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteOrganizationTaskCommentRaw(requestParameters, initOverrides);
        });
    }
    /**
     */
    getHealthCheckRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/health-check`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     */
    getHealthCheck(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getHealthCheckRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    getOrganizationTaskRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.orgID === null || requestParameters.orgID === undefined) {
                throw new runtime.RequiredError('orgID', 'Required parameter requestParameters.orgID was null or undefined when calling getOrganizationTask.');
            }
            if (requestParameters.taskID === null || requestParameters.taskID === undefined) {
                throw new runtime.RequiredError('taskID', 'Required parameter requestParameters.taskID was null or undefined when calling getOrganizationTask.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/organizations/{orgID}/tasks/{taskID}`.replace(`{${"orgID"}}`, encodeURIComponent(String(requestParameters.orgID))).replace(`{${"taskID"}}`, encodeURIComponent(String(requestParameters.taskID))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetTaskResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    getOrganizationTask(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getOrganizationTaskRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    getOrganizationTaskCommentAttachmentLinkRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.orgID === null || requestParameters.orgID === undefined) {
                throw new runtime.RequiredError('orgID', 'Required parameter requestParameters.orgID was null or undefined when calling getOrganizationTaskCommentAttachmentLink.');
            }
            if (requestParameters.taskID === null || requestParameters.taskID === undefined) {
                throw new runtime.RequiredError('taskID', 'Required parameter requestParameters.taskID was null or undefined when calling getOrganizationTaskCommentAttachmentLink.');
            }
            if (requestParameters.commentID === null || requestParameters.commentID === undefined) {
                throw new runtime.RequiredError('commentID', 'Required parameter requestParameters.commentID was null or undefined when calling getOrganizationTaskCommentAttachmentLink.');
            }
            if (requestParameters.attachmentID === null || requestParameters.attachmentID === undefined) {
                throw new runtime.RequiredError('attachmentID', 'Required parameter requestParameters.attachmentID was null or undefined when calling getOrganizationTaskCommentAttachmentLink.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/organizations/{orgID}/tasks/{taskID}/comments/{commentID}/attachments/{attachmentID}`.replace(`{${"orgID"}}`, encodeURIComponent(String(requestParameters.orgID))).replace(`{${"taskID"}}`, encodeURIComponent(String(requestParameters.taskID))).replace(`{${"commentID"}}`, encodeURIComponent(String(requestParameters.commentID))).replace(`{${"attachmentID"}}`, encodeURIComponent(String(requestParameters.attachmentID))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => AttachmentLinkFromJSON(jsonValue));
        });
    }
    /**
     */
    getOrganizationTaskCommentAttachmentLink(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getOrganizationTaskCommentAttachmentLinkRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    getOrganizationTaskCommentsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.orgID === null || requestParameters.orgID === undefined) {
                throw new runtime.RequiredError('orgID', 'Required parameter requestParameters.orgID was null or undefined when calling getOrganizationTaskComments.');
            }
            if (requestParameters.taskID === null || requestParameters.taskID === undefined) {
                throw new runtime.RequiredError('taskID', 'Required parameter requestParameters.taskID was null or undefined when calling getOrganizationTaskComments.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/organizations/{orgID}/tasks/{taskID}/comments`.replace(`{${"orgID"}}`, encodeURIComponent(String(requestParameters.orgID))).replace(`{${"taskID"}}`, encodeURIComponent(String(requestParameters.taskID))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CommentFromJSON));
        });
    }
    /**
     */
    getOrganizationTaskComments(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getOrganizationTaskCommentsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Search for organization tasks
     */
    searchOrganizationTasksRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.orgID === null || requestParameters.orgID === undefined) {
                throw new runtime.RequiredError('orgID', 'Required parameter requestParameters.orgID was null or undefined when calling searchOrganizationTasks.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/organizations/{orgID}/tasks/search`.replace(`{${"orgID"}}`, encodeURIComponent(String(requestParameters.orgID))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: SearchOrganizationTasksInputToJSON(requestParameters.searchOrganizationTasksInput),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TasksSearchResponseInnerFromJSON));
        });
    }
    /**
     * Search for organization tasks
     */
    searchOrganizationTasks(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.searchOrganizationTasksRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Search for organization tasks with details
     */
    searchOrganizationTasksWithDetailsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.orgID === null || requestParameters.orgID === undefined) {
                throw new runtime.RequiredError('orgID', 'Required parameter requestParameters.orgID was null or undefined when calling searchOrganizationTasksWithDetails.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/organizations/{orgID}/tasks/search-with-details`.replace(`{${"orgID"}}`, encodeURIComponent(String(requestParameters.orgID))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: SearchOrganizationTasksInputToJSON(requestParameters.searchOrganizationTasksInput),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TaskWithDetailsResponseFromJSON));
        });
    }
    /**
     * Search for organization tasks with details
     */
    searchOrganizationTasksWithDetails(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.searchOrganizationTasksWithDetailsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Search for tasks
     */
    searchTasksRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/tasks/search`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: SearchTasksInputToJSON(requestParameters.searchTasksInput),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TasksSearchResponseInnerFromJSON));
        });
    }
    /**
     * Search for tasks
     */
    searchTasks(requestParameters = {}, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.searchTasksRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Search for tasks with details
     */
    searchTasksWithDetailsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/tasks/search-with-details`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: SearchTasksInputToJSON(requestParameters.searchTasksInput),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TaskWithDetailsResponseFromJSON));
        });
    }
    /**
     * Search for tasks with details
     */
    searchTasksWithDetails(requestParameters = {}, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.searchTasksWithDetailsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    updateOrganizationTaskRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.orgID === null || requestParameters.orgID === undefined) {
                throw new runtime.RequiredError('orgID', 'Required parameter requestParameters.orgID was null or undefined when calling updateOrganizationTask.');
            }
            if (requestParameters.taskID === null || requestParameters.taskID === undefined) {
                throw new runtime.RequiredError('taskID', 'Required parameter requestParameters.taskID was null or undefined when calling updateOrganizationTask.');
            }
            if (requestParameters.ifMatch === null || requestParameters.ifMatch === undefined) {
                throw new runtime.RequiredError('ifMatch', 'Required parameter requestParameters.ifMatch was null or undefined when calling updateOrganizationTask.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (requestParameters.ifMatch !== undefined && requestParameters.ifMatch !== null) {
                headerParameters['If-Match'] = String(requestParameters.ifMatch);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/organizations/{orgID}/tasks/{taskID}`.replace(`{${"orgID"}}`, encodeURIComponent(String(requestParameters.orgID))).replace(`{${"taskID"}}`, encodeURIComponent(String(requestParameters.taskID))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: TaskUpdateInputToJSON(requestParameters.taskUpdateInput),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => TaskResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    updateOrganizationTask(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateOrganizationTaskRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    updateOrganizationTaskStateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.orgID === null || requestParameters.orgID === undefined) {
                throw new runtime.RequiredError('orgID', 'Required parameter requestParameters.orgID was null or undefined when calling updateOrganizationTaskState.');
            }
            if (requestParameters.taskID === null || requestParameters.taskID === undefined) {
                throw new runtime.RequiredError('taskID', 'Required parameter requestParameters.taskID was null or undefined when calling updateOrganizationTaskState.');
            }
            if (requestParameters.ifMatch === null || requestParameters.ifMatch === undefined) {
                throw new runtime.RequiredError('ifMatch', 'Required parameter requestParameters.ifMatch was null or undefined when calling updateOrganizationTaskState.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (requestParameters.ifMatch !== undefined && requestParameters.ifMatch !== null) {
                headerParameters['If-Match'] = String(requestParameters.ifMatch);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/organizations/{orgID}/tasks/{taskID}/state`.replace(`{${"orgID"}}`, encodeURIComponent(String(requestParameters.orgID))).replace(`{${"taskID"}}`, encodeURIComponent(String(requestParameters.taskID))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: TaskUpdateStateInputToJSON(requestParameters.taskUpdateStateInput),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => TaskResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    updateOrganizationTaskState(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateOrganizationTaskStateRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Uploads an attachment to tasks S3 bucket
     */
    uploadAttachmentRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.fileName === null || requestParameters.fileName === undefined) {
                throw new runtime.RequiredError('fileName', 'Required parameter requestParameters.fileName was null or undefined when calling uploadAttachment.');
            }
            const queryParameters = {};
            if (requestParameters.fileName !== undefined) {
                queryParameters['fileName'] = requestParameters.fileName;
            }
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/octet-stream';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/attachments`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters.body,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => AttachmentFromJSON(jsonValue));
        });
    }
    /**
     * Uploads an attachment to tasks S3 bucket
     */
    uploadAttachment(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.uploadAttachmentRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
